<template>
  <div
    v-if="!route.meta.isDesktop"
    class="page main_container"
  >
    <div class="content">
      <div class="central-image-wrapper">
        <img
          width="278"
          height="296"
          class="central-image"
          src="@/assets/images/system/new_version_available.png"
        />
        <Logo
          class="project-logo"
          fit
        />
      </div>

      <Typography
        variant="subtitle"
        style="margin-bottom: 8px; margin-top: 32px"
        center
      >
        Ура! У нас вышла новая версия платформы!
      </Typography>

      <Typography
        variant="body1"
        center
      >
        Обновление происходит мгновенно — просто нажми на <span
          style="font-weight: 700"
        >«Обновить»</span>
      </Typography>
    </div>

    <div class="update-button-wrap">
      <AppButton
        full-width
        :loading="isRefreshing"
        @click="refresh"
      >
        Обновить
      </AppButton>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'

import store from '@/store/store.js'

import AppButton from '@/components/UI/AppButton.vue'
import Logo from '@/components/UI/Logo.vue'
import Typography from '@/components/UI/Typography.vue'

const route = useRoute()

const isRefreshing = computed(() => store.state.app.isVersionRefreshing)

onBeforeMount(() => {
  if (route.meta.isDesktop) {
    void refresh()
  }
})

async function refresh() {
  await store.dispatch('app/setIsVersionRefreshing', true)

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      await registration.unregister()
    }
  } catch (error) {
    console.log('e', error)
  } finally {
    window.location.reload(true)
  }
}
</script>

<style lang="scss" scoped>
.page {
  // TMA: WebView is full-height; only the Telegram sheet is visible.
  // Size layout to stable --document-height; pin CTA to live --tg-viewport-height
  // (same approach as BottomAppBar) so expand/collapse cannot hide the button.
  box-sizing: border-box;
  position: relative;
  min-height: var(--document-height, 100svh);
  max-height: var(--document-height, 100svh);
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  padding: 36px;
  padding-bottom: 96px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  margin-bottom: auto;
  flex-shrink: 1;
  min-height: 0;
}

.central-image-wrapper {
  position: relative;
  flex-shrink: 1;
  min-height: 0;

  .central-image {
    display: block;
    max-width: 100%;
    height: auto;
    max-height: min(296px, calc(var(--document-height, 100svh) * 0.38));
    object-fit: contain;
  }

  .project-logo {
    position: absolute;
    top: calc(50% - 2px);
    left: calc(50% + 32px);
    transform: translate(-50%, -50%);

    width: 98px;
    height: 27px;
  }
}

.update-button-wrap {
  position: fixed;
  left: 50%;
  bottom: auto;
  z-index: 2;
  width: min(448px, calc(100% - 32px));
  // Same pin as BottomAppBar: visible sheet bottom via live viewport − webview height.
  top: auto;
  bottom: 36px;
  transform: translate3d(
    -50%,
    calc(
      var(--tg-viewport-height, var(--tma-visible-height, var(--tma-webview-height, 100vh)))
      - var(--tma-webview-height, 100vh)
    ),
    0
  );
}
</style>
